module.exports = __webpack_public_path__ + "img/60000.2d690c22.jpg";